import {
  booleanAttribute,
  Component,
  Input,
  input,
  type OnChanges,
  type SimpleChanges,
} from '@angular/core';
import { FinoCommonModule } from '@fino-ui/common';
import { FinoTranslationModule } from '@fino-ui/translation';
import { clone, find, get, isArray, map, remove } from 'lodash';
import { PROPERTIES } from './tenant-infos.constants';

@Component({
  selector: 'app-tenant-infos',
  templateUrl: './tenant-infos.component.html',
  styleUrls: ['./tenant-infos.component.sass'],
  imports: [FinoTranslationModule, FinoCommonModule],
})
export class TenantInfosComponent implements OnChanges {
  @Input()
  isExpanded: boolean = false;

  readonly infos = input<any>(undefined);

  readonly hideIbans = input<boolean, unknown>(undefined, {
    transform: booleanAttribute,
  });

  propertiesToShow: any[];

  ngOnChanges(_changes: SimpleChanges) {
    this.propertiesToShow = remove(clone(PROPERTIES), (el) => {
      // they want to see oldIban always
      return !(el.path.includes('newIban') && this.hideIbans());
    });
  }

  getProperty(path: string | string[]): string {
    if (isArray(path)) {
      return find(
        map(path, (p) => this.getProperty(p)),
        (e) => e,
      ) as string;
    }
    return get(this.infos(), path);
  }

  toggleExpanded() {
    this.isExpanded = !this.isExpanded;
  }
}
